import {I18nextProvider} from 'react-i18next';
import './App.css';
import Router from './routes';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import i18n from './i18n';
import SessionGate from './components/SessionGate';

function App() {
  return (
    <>
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="light"
      />

      <I18nextProvider i18n={i18n}>
        <SessionGate>
          <Router />
        </SessionGate>
      </I18nextProvider>
    </>
  );
}

export default App;
